import { Component, Input, OnDestroy, OnInit, input } from '@angular/core';
import { ZiroFormAbstractDirective } from '../../../../../../../../forms/ziro-form-abstract.directive';
import { ZiroFormConfig } from '../../../../../../../../forms/ziro-forms-models';
import { Observable, of, Subscription } from 'rxjs';
import { ZiroFormStateService } from '../../../../../../../../forms/ziro-form-state.service';
import { ZiroIcons } from '../../../../../../../../shared/models/ziro-icons.enum';

export interface HelpdeskAdAttributesEntity {
  [key: string]: string;
}

@Component({
  selector: 'ziro-helpdesk-ad-attributes-form',
  templateUrl: './helpdesk-ad-attributes-form.component.html',
  standalone: false,
})
export class HelpdeskAdAttributesFormComponent
  extends ZiroFormAbstractDirective<HelpdeskAdAttributesEntity>
  implements OnInit, OnDestroy
{
  protected _ziroFormStateService: ZiroFormStateService;

  // TODO: Skipped for migration because:
  //  This input overrides a field from a superclass, while the superclass field
  //  is not migrated.
  @Input() formConfig: ZiroFormConfig;
  readonly attributeFields = input<string[]>();
  readonly initialEntity = input<HelpdeskAdAttributesEntity>();
  hiddenFields: string[] = [];
  ziroIcons = ZiroIcons;
  private _isFirstCompleteLoad = true;
  private _subscriptions: Subscription = new Subscription();

  ngOnInit(): void {
    const updateSub = this.ziroFormsUpdate$.subscribe((update) => {
      if (Object.values(update.new).length === this.attributeFields().length && this._isFirstCompleteLoad) {
        this._isFirstCompleteLoad = false;
        this.fieldComponents.forEach((fieldComponent) => {
          this.fieldChannels[fieldComponent.fieldId()].entitySource.next(
            this.initialEntity()[fieldComponent.fieldId()],
          );
          const fieldId = fieldComponent.fieldId();
          if (
            this.formConfig.fields[fieldId].hidden() &&
            this.initialEntity()[fieldId] === this.formConfig.fields[fieldId].defaultValue()
          ) {
            this.hiddenFields.push(fieldId);
          }
        });
      }
    });
    this._subscriptions.add(updateSub);
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  protected submit(): Observable<any> {
    return of(null);
  }
}
